import {
  StyleSheet,
  ScrollView,
  View,
  TouchableOpacity,
  Image,
} from "react-native";
import React from "react";
import LinearGradient from "react-native-linear-gradient";
import color from "@constants/color";
import CustomText from "../CustomText";
import Cross from "@assets/svg/Cross";
import { OrderReturnStatus } from "@assets/svg/MyDeliveries";
import RTODeliveryCard from "./RTODeliveryCard";

const InAppRTOModal = ({
  route = {},
  closeModal = () => {},
  onPressNeeded = () => {},
  item = {},
  ordersCount = 0,
}) => {
  return (
    <View style={styles.modalContainer}>
      <ScrollView
        style={styles.scrollView}
        contentContainerStyle={styles.contentContainerStyle}
      >
        <LinearGradient
          colors={[color.white, "#FFEAEA"]}
          style={styles.viewContainer}
        >
          <TouchableOpacity style={styles.crossButton} onPress={closeModal}>
            <Cross width={12} height={12} />
          </TouchableOpacity>
          {item?.imageUrl ? (
            <Image
              resizeMode={"contain"}
              style={styles.inAppIcon}
              source={{
                uri: item.imageUrl,
              }}
            />
          ) : null}
          {item?.subtitle ? (
            <CustomText
              variant="title_16"
              newfont={true}
              style={styles.subTitle}
            >
              {item.subtitle}
            </CustomText>
          ) : null}
          {item?.title ? (
            <CustomText
              variant="heading_24"
              newfont={true}
              style={styles.title}
            >
              {item.title}
            </CustomText>
          ) : null}
          {item?.warningMessage || item?.errorMessage ? (
            <View style={styles.ordersTitleContainer}>
              <OrderReturnStatus orderStatus={"usersUnableToDeliver"} />
              <CustomText
                variant="body_text_2"
                newfont={true}
                style={styles.ordersTitle}
              >
                {item.errorMessage || item.warningMessage}
              </CustomText>
            </View>
          ) : null}
          {item?.order_items?.length !== 0 ? (
            <RTODeliveryCard
              onPressNeeded={onPressNeeded}
              item={item}
              route={route}
              ordersCount={ordersCount}
            />
          ) : null}
        </LinearGradient>
      </ScrollView>
    </View>
  );
};

export default InAppRTOModal;

const styles = StyleSheet.create({
  contentContainerStyle: {
    flexDirection: "column",
    justifyContent: "flex-end",
    flexGrow: 1,
  },
  scrollView: {
    maxHeight: "90%",
  },
  modalContainer: {
    backgroundColor: color.modalBackground,
    flexDirection: "column",
    justifyContent: "flex-end",
    flex: 1,
  },
  viewContainer: {
    backgroundColor: color.white,
    paddingTop: 16,
    paddingBottom: 24,
    borderTopEndRadius: 20,
    borderTopStartRadius: 20,
    overflow: "hidden",
  },
  crossButton: {
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: color.shadowLighter,
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "flex-end",
    marginEnd: 16,
  },
  inAppIcon: {
    width: 133,
    height: 109,
    marginStart: -11.5,
    marginTop: 15,
  },
  title: {
    color: color.mediumBlack,
    marginTop: 20,
    marginHorizontal: 16,
  },
  subTitle: {
    color: color.mediumBlack,
    marginTop: 8,
    marginHorizontal: 16,
    lineHeight: 24,
  },
  ordersTitleContainer: {
    flexDirection: "row",
    alignContent: "center",
    paddingHorizontal: 16,
    marginTop: 15,
  },
  ordersTitle: {
    color: color.plain_red,
    marginStart: 8,
  },
});
